/*
 * Project: bellcloud
 * File: packages/utils/device/detectBellProtocol.ts
 * Author: SWAN
 * Created: 2025-01-30
 * Description: Automatic protocol detection utility
 *   - deviceTypes.ts의 DEVICE_TYPE_CONFIGS 레지스트리를 사용하여
 *     새 기기 타입 추가 시 이 파일 수정 불필요
 */

import {
  DeviceType,
  type ProtocolType,
  detectDeviceTypeFromSerial,
  detectDeviceTypeFromPacketSource,
  getProtocolForDeviceType,
} from '../../types/device/common/deviceTypes';

interface ProtocolDetectionResult {
  protocol: ProtocolType;
  deviceType: DeviceType;
}

/**
 * 통합 프로토콜 자동 감지
 * - `packet`이 넘어오면 수신 경로: packet[2] Source가 BELLMINI(0x01)/BELLLITE(0x05)일 때만 그에 맞춰 MINI/LITE 결정
 * - 송신/패킷 생성 등에서는 `packet` 없이 serialNumber만 넘기면 기존과 동일(시리얼 기반)
 */
export function detectProtocol(options: {
  serialNumber?: string;
  packet?: number[];
}): ProtocolDetectionResult {
  const { serialNumber, packet } = options;
  if (packet && packet.length >= 3) {
    const fromSource = detectDeviceTypeFromPacketSource(packet[2]);
    if (fromSource !== null) {
      return {
        protocol: getProtocolForDeviceType(fromSource),
        deviceType: fromSource,
      };
    }
  }
  const deviceType = detectDeviceTypeFromSerial(serialNumber ?? '');
  return {
    protocol: getProtocolForDeviceType(deviceType),
    deviceType,
  };
}
